import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';

@Component({
  standalone: true,
  selector: 'pm-form-field-text',
  imports: [InputTextModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-text.component.html',
  styleUrl: './pm-form-field-text.component.scss',
})
export class PmFormFieldTextComponent extends FormFieldComponent {
  checkOnlyDigits(event: KeyboardEvent) {
    if (!this.formField.onlyDigits) return;
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
}
